import React from 'react';

function ProductGrid({ products, onTryNow }) {
  return (
    <div className="productListHeadMain">
      {products.map((product) => {
        return (
          <div key={product.id} className="">
            <div className="h_200x d-flex flex-column justify-content-between px-3 py-3 bg-white border bd_gary_light br_10">
              <div>
                <h3 className="text-black mb-2 font_16 mb-2">
                  {product.productTitle}
                </h3>
                <p className="text_gray10 font_14 font_400 productText">
                  {product.productSubTitle}
                </p>
              </div>
              <div>
                <div className=" mb-3 font_600 rounded-pill text-black w_fit_content">
                  {`${product.productWeightage} credit/ Hit`}
                </div>
                {product.isActive ? (
                  <div
                    className="d-flex text-white justify-content-center bg-black align-items-center cardIconMain font_13 w_100 py-2  cursor-pointer gap-4"
                    onClick={() => onTryNow(product)}
                  >
                    Try Now <i class="fa-solid fa-angle-right"></i>
                  </div>
                ) : (
                  <div className="coming-soon-badge text-black font_13 font_400">
                    🚀 Coming Soon
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default React.memo(ProductGrid);
